import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Button } from '../Button';
import { Parallax } from '../common/Parallax';
export function Hero() {
  return <section className="relative h-[90vh] min-h-[600px] w-full" data-id="element-145">
      <Parallax imageUrl="https://images.unsplash.com/photo-1584622650111-993a426fbf0a?q=80&w=2940&auto=format&fit=crop" className="absolute inset-0 w-full h-full" overlayClassName="bg-[linear-gradient(90deg,rgba(14,42,71,0.85)_0%,rgba(14,42,71,0.55)_45%,rgba(14,42,71,0)_80%)]" data-id="element-146">
        <div className="container mx-auto px-4 md:px-6 h-full flex flex-col justify-center" data-id="element-147">
          <div className="max-w-2xl text-brand-white pt-20" data-id="element-148">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="font-display font-bold text-4xl md:text-5xl lg:text-6xl leading-tight mb-6 [text-shadow:0_2px_12px_rgba(0,0,0,0.35)]" data-id="element-149">
              Immaculate, Inside & Out
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="text-lg md:text-xl text-white mb-10 max-w-xl leading-relaxed [text-shadow:0_2px_12px_rgba(0,0,0,0.35)]" data-id="element-150">
              Professional deep cleaning for your home, move-out, or Airbnb.
              Spotless results, every time. Available 24/7.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-151">
              <Button className="bg-brand-aqua hover:bg-brand-aqua-dark text-white h-14 px-8 text-lg font-semibold rounded-full w-full sm:w-auto" data-id="element-152">
                Get a Free Quote
              </Button>
              <Button className="border-0 bg-white text-brand-navy hover:bg-brand-gray h-14 px-8 text-lg font-semibold rounded-full w-full sm:w-auto" data-id="element-153">
                View Services
              </Button>
            </motion.div>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.8
          }} className="flex items-center gap-2 text-sm md:text-base text-white font-medium" data-id="element-154">
              <span data-id="element-155">24/7 Availability</span>
              <span className="text-brand-aqua" data-id="element-156">•</span>
              <span data-id="element-157">Satisfaction Guaranteed</span>
              <span className="text-brand-aqua" data-id="element-158">•</span>
              <span data-id="element-159">Trusted & Insured</span>
            </motion.div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1.2
      }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center text-brand-white" data-id="element-160">
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} data-id="element-161">
            <ChevronDown className="h-8 w-8 opacity-70" strokeWidth={1.5} data-id="element-162" />
          </motion.div>
        </motion.div>
      </Parallax>
    </section>;
}